import {AxiosError} from 'axios'
import * as bootstrap from 'bootstrap'
import {useLang} from '../../../../../_metronic/i18n/Metronici18n'
import {deleteExperimentType} from '../../../../modules/auth/core/_requests'
import {KTSVG} from '../../../../../_metronic/helpers'

function DeleteExperimentTypeModal({checkList, setAction}: any) {
  const lang = useLang()
  const deleteFunction = async () => {
    try {
      const {data} = await deleteExperimentType(
        checkList[0].experimentId,
        checkList[0].dictionaryId,
        checkList[0].experimentTypeName,
        lang
      )
      setAction(true)
      //Modal close
      const modal = bootstrap.Modal.getOrCreateInstance('#deleteTabContentEType_modal')
      modal.hide()
      //
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }
  return (
    <div className='modal fade' tabIndex={-1} id={`deleteTabContentEType_modal`}>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Delete Type</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <p>Are you sure you want to delete the Type?</p>
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
              Close
            </button>
            <button type='button' className='btn btn-primary' onClick={() => deleteFunction()}>
              Delete Type
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteExperimentTypeModal
